  <template>
   <b-modal style="padding:15px" size="lg" id="AddWheatTypeModal" ref="modal" title="Add Wheat Type" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddWheatTypeForm != undefined ? !this.$refs.AddWheatTypeForm.checkValidity() : true">
        <form ref="AddWheatTypeForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-12">
               <b-form-group  label="Name" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "TypeName"  required></b-form-input>
              </b-form-group>
            </div>
          </div>     
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddWheatType',
    data(){
        return{
          moduleName:'Edit Wheat Type',   
          TypeName:'',
		}
  },

 props:
 {
   role:{
     type:Object,
     default:null
   }
 },


methods:{
  
   addWheatType(){ 
        
     axios.post('/wheattype/Add', 
      {"TypeName":this.TypeName, "CompanyId":this.$auth.user().companyId
      })
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Wheat type has been added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go();
            }
             else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddWheatTypeForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.TypeName = '';  
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatType()
       
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('AddWheatTypeModal')
        
        })
      },

 

  }
	

}
</script>
